import React from 'react';
import { uiChartViewBtn, type ChartViewKey } from '../../../ui/buttonClasses';

interface ViewToggleProps {
  views: Record<ChartViewKey, boolean>;
  onViewChange: (view: ChartViewKey) => void;
  className?: string;
  containerWidth?: number;
}

const buttons: Array<{ key: ChartViewKey; label: string }> = [
  { key: 'ranges', label: 'Ranges' },
  { key: 'percentiles', label: 'Percentiles' },
  { key: 'peaks', label: 'Peaks' },
  { key: 'density', label: 'Density' },
];

const ViewToggle: React.FC<ViewToggleProps> = ({ views, onViewChange, className }) => {
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className || ''}`}>
      {buttons.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          onClick={() => onViewChange(key)}
          className={uiChartViewBtn(key, views[key])}
          aria-pressed={views[key]}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;
